/* ============================================================
   ORBE PARIS — Hero showroom (hero-showroom-orbe-v1)
   - Révélation orchestrée à l'entrée (.is-ready)
   - Sélecteur de formats (cross-fade, aucun layout shift)
   - Micro-parallaxe pointeur (desktop, optionnelle)
   Vanilla JS, sans dépendance. Idempotent + shopify:section:load.
   ============================================================ */
(function () {
  'use strict';

  var prefersReduced = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  function initHero(root) {
    if (!root || root.dataset.heroInit === '1') return;
    root.dataset.heroInit = '1';

    var reduce = prefersReduced();

    /* 1) Révélation — posée AVANT tout le reste pour qu'aucune erreur
       ultérieure ne laisse le contenu masqué. */
    var reveal = function () { root.classList.add('is-ready'); };
    if (reduce) {
      reveal();
    } else {
      // Double rAF : laisse le navigateur peindre l'état initial avant la transition.
      requestAnimationFrame(function () { requestAnimationFrame(reveal); });
      // Filet de sécurité si rAF est throttlé (onglet en arrière-plan, webview) :
      // le contenu ne doit jamais rester masqué.
      setTimeout(reveal, 200);
    }

    /* 2) Sélecteur de formats */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-tab]'));
    var medias = root.querySelectorAll('[data-hero-media]');
    var infos = root.querySelectorAll('[data-hero-info]');

    // Charge une image différée (data-src/data-srcset -> src/srcset).
    function promote(img) {
      if (!img) return;
      var ds = img.getAttribute('data-src');
      if (ds) { img.setAttribute('src', ds); img.removeAttribute('data-src'); }
      var dss = img.getAttribute('data-srcset');
      if (dss) { img.setAttribute('srcset', dss); img.removeAttribute('data-srcset'); }
    }

    function activate(idx) {
      idx = String(idx);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-hero-tab') === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      medias.forEach(function (m) {
        var on = m.getAttribute('data-hero-media') === idx;
        m.classList.toggle('is-active', on);
        if (on) { promote(m.querySelector('img')); } // charge immédiatement le modèle choisi
      });
      infos.forEach(function (inf) {
        inf.classList.toggle('is-active', inf.getAttribute('data-hero-info') === idx);
      });
    }

    // Précharge les images inactives à l'idle (après le LCP), pour un
    // changement de modèle instantané sans pénaliser le chargement initial.
    var preloadRest = function () {
      medias.forEach(function (m) { promote(m.querySelector('img')); });
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadRest, { timeout: 2600 });
    } else {
      setTimeout(preloadRest, 1800);
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-hero-tab')); });
      // Navigation clavier façon tablist (flèches gauche/droite).
      t.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        if (!dir) return;
        e.preventDefault();
        var next = (i + dir + tabs.length) % tabs.length;
        tabs[next].focus();
        activate(tabs[next].getAttribute('data-hero-tab'));
      });
    });

    /* 3) Micro-parallaxe pointeur — desktop pointer fin, hors reduced-motion.
       Pas de boucle rAF permanente : on réagit aux events pointermove. */
    var stage = root.querySelector('[data-hero-stage]');
    var motionOn = root.getAttribute('data-product-motion') === 'true';
    var finePointer = window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (stage && motionOn && !reduce && finePointer) {
      var raf = null;
      var pending = null;
      var apply = function () {
        raf = null;
        if (!pending) return;
        stage.style.setProperty('--hero-px', pending.x + 'px');
        stage.style.setProperty('--hero-py', pending.y + 'px');
      };
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;   // -0.5 .. 0.5
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        pending = { x: (dx * 5).toFixed(2), y: (dy * 4).toFixed(2) };
        if (raf === null) raf = requestAnimationFrame(apply);       // coalesce, pas de boucle infinie
      }, { passive: true });
      root.addEventListener('pointerleave', function () {
        pending = { x: '0.00', y: '0.00' };
        if (raf === null) raf = requestAnimationFrame(apply);
      });
    }
  }

  function initAll(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    var nodes = scope.querySelectorAll('[data-hero-showroom]');
    Array.prototype.forEach.call(nodes, initHero);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Theme Editor : ré-injection de la section -> ré-initialisation propre.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
